import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import { CustomUserPaymentsAdapter } from '../custom-user-payments.adapter';
import { InvoiceHistory, InvoiceSummaryAvisResponse, InvoiceSummaryDetailResponse } from '../custom-user-payments.models';
import * as CustomUserPaymentsActions from './custom-user-payments-actions';

@Injectable()
export class CustomUserPaymentsEffects {

    constructor(
        private actions$: Actions,
        private customUserPaymentsAdapter: CustomUserPaymentsAdapter
    ) {}

    getUserPayments$ = createEffect(() => {
        return this.actions$.pipe(
          ofType(CustomUserPaymentsActions.getUserPayments),
          switchMap(() =>
            this.customUserPaymentsAdapter
            .getUserPayments()
              .pipe(
                map((invoiceOverview: InvoiceHistory) =>
                CustomUserPaymentsActions.getUserPaymentsSuccess
                  ({
                    invoiceOverview,
                  })
                ),
                catchError((error) =>
                  of(
                    CustomUserPaymentsActions.getUserPaymentsFailure({
                      error,
                    })
                  )
                )
              )
          )
        );
    });

    searchUserPayments$ = createEffect(() => {
      return this.actions$.pipe(
        ofType(CustomUserPaymentsActions.searchUserPayments),
        switchMap((action) =>
          this.customUserPaymentsAdapter
            .searchUserPayments(
              action.invoiceHistoryRequestData
            )
            .pipe(
              map((invoiceOverview: InvoiceHistory) =>
              CustomUserPaymentsActions.searchUserPaymentsSuccess
              ({
                invoiceOverview,
              })
            ),
            catchError((error) =>
              of(
                CustomUserPaymentsActions.searchUserPaymentsFailure({
                  error,
                })
              )
            )
            )
        )
      );
    });

    getUserPaymentsDetails$ = createEffect(() => {
      return this.actions$.pipe(
        ofType(CustomUserPaymentsActions.getUserPaymentsDetails),
        switchMap((action) =>
          this.customUserPaymentsAdapter
            .getUserPaymentsDetails(
              action.invoiceNumber,
              action.companyCode,
              action.bookingYear,
              action.bookingTime,
            )
            .pipe(
              map((invoiceDetails: InvoiceSummaryDetailResponse) =>
              CustomUserPaymentsActions.getUserPaymentsDetailsSuccess
                ({
                  invoiceDetails,
                })
              ),
              catchError((error) =>
                of(
                  CustomUserPaymentsActions.getUserPaymentsDetailsFailure({
                    error,
                  })
                )
              )
            )
        )
      );
    });

    getUserPaymentsAvis$ = createEffect(() => {
      return this.actions$.pipe(
        ofType(CustomUserPaymentsActions.getUserPaymentsAvis),
        switchMap((action) =>
          this.customUserPaymentsAdapter
            .getUserPaymentsAvis(
              action.avisNumber,
              action.avisDate,
            )
            .pipe(
              map((invoiceAvis: InvoiceSummaryAvisResponse) =>
              CustomUserPaymentsActions.getUserPaymentsAvisSuccess
                ({
                  invoiceAvis,
                })
              ),
              catchError((error) =>
                of(
                  CustomUserPaymentsActions.getUserPaymentsAvisFailure({
                    error,
                  })
                )
              )
            )
        )
      );
    });
}